import * as React from 'react';
import classnames from 'classnames';
import injectStyles from '../jss';
import styles from './BackButton.jss';
import { IconChevronLeft } from '../Icons';
var BackButton = function BackButton(_ref) {
  var classes = _ref.classes,
    goBack = _ref.goBack,
    className = _ref.className;
  return React.createElement("div", {
    className: classnames(classes.base, className)
  }, React.createElement(IconChevronLeft, {
    className: classes.icon,
    onClick: goBack
  }));
};
BackButton.styleRoot = 'BackButton';
export default injectStyles(styles)(BackButton);